<template>
  <div>
    <app-title>
      Manage Domain: {{domain}}
      <v-btn color="secondary" @click="$router.go(-1)">Back</v-btn>
    </app-title>
    <v-container grid-list-xs>
      <v-layout flex-child wrap>
        <v-flex xs6 md4 d-flex v-for="(action,index) in actions" :key="index">
          <v-sheet class="d-flex" color="grey lighten-3" height="20vh">
            <v-btn
              block
              :disabled="action.disable"
              style="height: 90%; "
              class="xs-2 title"
              color="primary"
              @click="navigate(action.url)"
            >{{action.text}}</v-btn>
          </v-sheet>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import {
  mapNamptFields,
  mapNamptMultiRowFields
} from "@/store/modules/forms/nampt";

export default {
  name: "linkActions",
  data() {
    return {
      actions: [
        { text: "Extensions", url: "link-extensions", disable: false },
        { text: "Service Flags", url: "link-serviceFlags", disable: false },
        { text: "Call Log", url: "link-callLog", disable: true },
        { text: "Hunt Groups", url: "link-huntGroups", disable: true },
        { text: "Registrations", url: "link-registrations", disable: true },
        { text: "Routing", url: "link-routing", disable: true },
        { text: "Audit Log", url: "link-audit", disable: true }
      ]
    };
  },
  computed: {
    ...mapNamptFields(["domain"])
  },
  methods: {
    navigate(url) {
      this.$router.push(`/link/${url}`);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>